import {
  ButtonSignup,
  ButtonSubmitted,
  ButtonRecoverPassword,
  ContainerPage,
  ContainerStyled,
  FormContainer,
} from "./styles";

import Header from "../../../components/Header";
import { WhatsApp } from "../../../components/WhatsApp";
import { Contact } from "../../../pages/Contact";

import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { useState } from "react";
import { Footer } from "../../../components/Footer";
import { sendCodeToEmail } from "../../../services/resources/EmailCode";

export const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [formRecoverPassword, setFormRecoverPassword] = useState(true);
  const [codeEmail, setCodeEmail] = useState("");
  const [codeEmailResponse, setCodeEmailResponse] = useState("");

  const { onLogin, onRegisterNewPassword } = useAuth();
  const navigate = useNavigate();

  const handleSignup = () => {
    navigate("/signup");
  };

  const handlePassword = () => {
    const data = {
      email,
      code: generateRandomPassword(),
    };
    setFormRecoverPassword(false);
    setPassword("");
    setErrorMessage("");
    sendCodeToEmail(data);
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = {
      email,
      password,
    };

    const response = await onLogin(data);

    if (!response?.id) {
      setErrorMessage("Login Inválido, tente novamente");
      setRecoverPassword(true);
      return;
    }

    navigate("/");
  };

  const handleNewPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = {
      email,
      password,
      codeEmailResponse,
    };

    if (codeEmail !== codeEmailResponse) {
      setErrorMessage(
        "Código inválido - verificar o código enviado por e-mail}"
      );
      return;
    }

    if (password.length < 6) {
      setErrorMessage(
        "Por favor, insira uma senha com mais de seis caracteres."
      );
      return;
    }

    const hasLetterAndNumber = /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(password);
    if (!hasLetterAndNumber) {
      setErrorMessage("A senha deve conter pelo menos uma letra e um número");
      return;
    }

    await onRegisterNewPassword(data);

    const dataLogin = {
      email,
      password,
    };

    const responseLogin = await onLogin(dataLogin);

    if (!responseLogin?.id) {
      setErrorMessage("E-mail não cadastrado!");
      return;
    }

    navigate("/");
  };

  function generateRandomPassword() {
    const passwordLength = 6;
    let password = "";

    for (let i = 0; i < passwordLength; i++) {
      const digit = Math.floor(Math.random() * 10);
      password += digit;
    }
    setCodeEmailResponse(password);
    return password;
  }

  return (
    <ContainerPage>
      <ContainerStyled>
        <Header />
        <FormContainer>
          {formRecoverPassword ? (
            <form onSubmit={handleLogin}>
              <h2>LOGIN</h2>
              <div className="login-form">
                <h3>EMAIL</h3>
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
              <div className="login-form">
                <h3>SENHA</h3>
                <input
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>

              {errorMessage && <p>{errorMessage}</p>}
              {recoverPassword ? (
                <ButtonRecoverPassword onClick={handlePassword}>
                  Esqueceu a senha? Clique aqui!
                </ButtonRecoverPassword>
              ) : (
                ""
              )}

              <div>
                <div>
                  <ButtonSubmitted type="submit">ENTRAR</ButtonSubmitted>
                  <ButtonSignup type="button" onClick={handleSignup}>
                    NÃO TEM UMA CONTA?
                  </ButtonSignup>
                </div>
              </div>
            </form>
          ) : (
            <form onSubmit={handleNewPassword}>
              <h2>CADASTRO - NOVA SENHA</h2>
              <div className="login-form">
                <h3>EMAIL</h3>
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
              <div className="login-form">
                <h3>NOVA SENHA</h3>
                <input
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>
              <div className="login-form">
                <h3>CÓDIGO DE VERIFICAÇÃO</h3>
                <input
                  type="password"
                  placeholder="código enviado por email"
                  value={codeEmail}
                  onChange={(event) => setCodeEmail(event.target.value)}
                />
              </div>
              {errorMessage && <p>{errorMessage}</p>}
              <div>
                <div>
                  <ButtonSubmitted type="submit">ENTRAR</ButtonSubmitted>
                  <ButtonSignup type="button" onClick={handleSignup}>
                    NÃO TEM UMA CONTA?
                  </ButtonSignup>
                </div>
              </div>
            </form>
          )}
        </FormContainer>
        <WhatsApp />
      </ContainerStyled>
      <Contact />
      <Footer />
    </ContainerPage>
  );
};
